import { render } from "./FooterContent.vue?vue&type=template&id=5473b6ac&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=5473b6ac&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5473b6ac"]])

export default __exports__